export { StatsigWrapperWithoutRedux as StatsigProvider } from 'lib/statsig/provider_no_redux'
